import { useState, useEffect } from 'react'
import { getAccessLink } from '../../Services/API';
import moment from 'moment';
import './style.scss'
import { useSearchParams, useNavigate } from 'react-router-dom';
import { conversationalFormsURL } from '../../Utils/common';

function SuccessEdit() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const [paramId, setParamId] = useState("")

    const handlePreview = async () => {
        try {
            const payload = {
                userId: sessionStorage?.principalId,
                iframeId: 1,
                configuration: {
                    formUUID: paramId,
                    principalId: sessionStorage?.principalId
                },
                expires: moment(new Date()).add(1, "day").format('YYYY-MM-DD hh:mm:ss')

            }
            const formDetails = await getAccessLink(payload);
            if (formDetails?.formUUID) {
                window.open(`${conversationalFormsURL}/?id=${formDetails.formUUID}`, '_blank');
            }
        } catch (e) {
            console.log("err", e)
        }
    }

    useEffect(() => {
        const id: string = searchParams.get("id") || "";
        if (id) {
            setParamId(id)
        } else {
            navigate('/notFound')
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <div className='success-edit-container'>
            <span>Form has been updated successfully</span>
            <button onClick={handlePreview}>Click here to preview the form</button>
        </div>
    )
}

export default SuccessEdit